import { Message } from 'element-ui'

/* 全局请求加载loading */
export default class LoadingRequest {
    constructor() {
        this.loading = null;
        this.needLoadingRequestCount = 0;
    }
    startLoading() {
        this.loading = Message({
            customClass: 'custom-message-loading',
            iconClass: 'el-icon-loading',
            message: '正在加载中...',
            duration: 0,
            // onClose: this.removeLoading()
        })
    }
    showFullScreenLoading() {
        if (document.getElementsByClassName('custom-message-loading').length == 0) {
            this.startLoading()
        }
        // if (this.needLoadingRequestCount === 0) {
        //     this.startLoading()
        // }
        // this.needLoadingRequestCount++
    }
    tryHideFullScreenLoading() {
        // if (this.needLoadingRequestCount <= 0) return
        // this.needLoadingRequestCount--
        // if (this.needLoadingRequestCount === 0) {
        //     this.endLoading()
        // }
        this.loading && this.endLoading()
    }
    endLoading() {
        setTimeout(() => {
            this.loading.close()
        }, 500);
    }
    /* 清除残留loading */
    removeLoading(e) {
        const oalMessageNode = [...document.getElementsByClassName('custom-message-loading')];
        console.log(oalMessageNode)
        if (oalMessageNode.length) {
            oalMessageNode.forEach(item => {
                item.remove()
            })
        }
    }
}
// if (document.getElementsByClassName('custom-message-loading').length == 0) {
//     loading = Message({
//         customClass: 'custom-message-loading',
//         iconClass: 'el-icon-loading',
//         message: '正在加载中...',
//         duration: 0
//     })
// }
// loading = this._Vue.prototype.$loading({
//     lock: true,
//     text: '加载中...',
//     spinner: 'el-icon-loading',
//     background: 'rgba(0, 0, 0, 0.7)'
// })



// WEBPACK FOOTER //
// ./src/plugins/ajax/loading.js